import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';


const Header = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const titleMap: Record<string, string> = {
        '/': '홈',
        '/announcement': '내 공고',
        '/announcement/matching': '내 공고',
        '/announcement/ongoing': '내 공고',
        '/announcement/completed': '내 공고',
        '/service-apply': '서비스 신청',
        '/service/apply/care': '서비스 신청',
        '/service/apply/escort': '서비스 신청',
        '/service/apply/housekeeping': '서비스 신청',
        '/task/findTask': '일감 찾기',
        '/task/myTask': '일감 찾기',
        '/wallet/charge': '충전하기',
        '/wallet/charge-list': '내 지갑',
        '/wallet/use-list': '내 지갑',
        '/wallet/refund-list': '내 지갑',
        '/wallet/accountManagement': '계좌관리',
        '/wallet/refund': '잔액환불',
        '/menu/myInfo': '내 정보관리',
        '/menu/seniorList': '어르신 관리',
        '/menu/changePaymentPassword': '결제비밀번호 변경',
        '/seniorAdd': '어르신 등록',
        '/alarmList': '알림내역',
        '/coordi/detail': '코디 정보 관리',
        '/coordi/edit': '코디 정보 수정',
        '/deleteAccount': '회원탈퇴',
        '/settlement/withdrawal': '출금하기',
        '/menu/favorite': '즐겨찾기',
        '/menu/company-info': '회사정보',
        '/desk/notice': '공지사항',
        '/desk/faq': '자주 묻는 질문',
        '/desk/inquiry': '제휴문의',
        '/desk/qna': '1:1문의',
        '/terms/termsList': '이용약관',
        '/nearby/shop': '내 주변 찾기'

    };
    let title = titleMap[pathname] ?? '';
    const getDynamicTitle = (pathname: string): string | null => {
        if (pathname.startsWith('/senior/')) return '어르신 상세';
        if (pathname.startsWith('/shop/')) return '거래처 상세';
        if (pathname.startsWith('/wallet/charge-list/')) return '충전상세';
        if (pathname.startsWith('/wallet/use-list/')) return '사용상세';
        if (pathname.startsWith('/wallet/refund-list/')) return '잔액환불상세';
        if (pathname.startsWith('/announcement/find/')) return '공고상세';
        if (pathname.startsWith('/settlement/settlement-list/')) return '내역상세';
        if (pathname.startsWith('/settlement/withdrawal-list/')) return '내역상세';
        if (matchPath('/announcement/:jobPostingCode/detail', pathname)) {
           return '공고 상세';
        }
        if (matchPath('/announcement/:jobPostingCode/coordi', pathname)) {
           return '지원 코디';
        }
        if (pathname.startsWith('/payment')) return '결제하기';
        return null;
    };
    title = getDynamicTitle(pathname) ?? titleMap[pathname] ?? '';

    return (
        <header className="sub-header">
            <div className="header-inner">
                <button
                    type="button"
                    className="backBtn"
                    onClick={() => navigate(-1)}
                >
                    <span className="blind">뒤로가기</span>
                </button>

                <h1 className="subtitle">{title}</h1>
                <button
                    type="button"
                    className="homeBtn"
                    onClick={() => navigate('/')}
                >
                    <span className="blind">홈으로</span>
                </button>
            </div>
        </header>
    );
};

export default Header;
